import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Form from '../../../../components/Form';
import Label from '../../../../components/Label';
import withCollegeService from '../withCollegeService';
import { gpaPattern } from '../validators';

import messages from './messages';
import '../styles.css';

function ErrorLabel({ error }) {
  const messageDefinition = error || messages.gpaInvalidError;
  return (
    <Label role="tooltip" basic color="red" pointing><FormattedMessage {...messageDefinition} /></Label>
  );
}

ErrorLabel.propTypes = {
  error: PropTypes.object,
};

export const QuarterPercentile = ({ onChange, initialValue, formatMessage }) => (
  <Form.Field>
    <Form.Input
      name="25"
      fluid
      label={formatMessage(messages['25'])}
      placeholder={formatMessage(messages['25'])}
      value={initialValue.value}
      data-cy="premium-Hem-Gpa-25-Percentile-Input"
      onChange={(e, { value }) => {
        onChange(e, { value });
      }}
      error={initialValue.showError}
      styleName="error-field"
      maxLength="3"
    />
    {initialValue.showError && <ErrorLabel error={gpaPattern.test(initialValue.value) ? messages.gpaInvalid25Error : null} />}
  </Form.Field>
);

QuarterPercentile.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};
const QuarterPercentileComponent = withCollegeService(QuarterPercentile, 'overview.gpa.25', '', {
  value: 'field_he_gpa_25th_percentile',
});

export const AveragePercentile = ({ onChange, initialValue, formatMessage }) => (
  <Form.Field>
    <Form.Input
      name="50"
      fluid
      label={formatMessage(messages['50'])}
      placeholder={formatMessage(messages['50'])}
      value={initialValue.value}
      data-cy="premium-Hem-Gpa-Average-Input"
      onChange={(e, { value }) => {
        onChange(e, { value });
      }}
      error={initialValue.showError}
      styleName="error-field"
      maxLength="3"
    />
    {initialValue.showError && <ErrorLabel error={gpaPattern.test(initialValue.value) ? messages.gpaInvalid50Error : null} />}
  </Form.Field>
);

AveragePercentile.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};
const AveragePercentileComponent = withCollegeService(AveragePercentile, 'overview.gpa.50', '', {
  value: 'field_he_gpaaverage',
});

export const ThreeQuarterPercentile = ({ onChange, initialValue, formatMessage }) => (
  <Form.Field>
    <Form.Input
      name="75"
      fluid
      label={formatMessage(messages['75'])}
      placeholder={formatMessage(messages['75'])}
      value={initialValue.value}
      data-cy="premium-Hem-Gpa-75-Percentile-Input"
      onChange={(e, { value }) => {
        onChange(e, { value });
      }}
      error={initialValue.showError}
      styleName="error-field"
      maxLength="3"
    />
    {initialValue.showError && <ErrorLabel error={gpaPattern.test(initialValue.value) ? messages.gpaInvalid75Error : null} />}
  </Form.Field>
);

ThreeQuarterPercentile.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};
const ThreeQuarterPercentileComponent = withCollegeService(ThreeQuarterPercentile, 'overview.gpa.75', '', {
  value: 'field_he_gpa_75th_percentile',
});

const GpaForm = ({ formatMessage }) => (
  <Form>
    <QuarterPercentileComponent formatMessage={formatMessage} />
    <AveragePercentileComponent formatMessage={formatMessage} />
    <ThreeQuarterPercentileComponent formatMessage={formatMessage} />
  </Form>
);
GpaForm.propTypes = {
  formatMessage: PropTypes.func,
};

export default GpaForm;
